/**
 * Trusted shell origins that may send postMessage to this sub-app.
 *
 * Used for:
 *   1. BIZTADA_AUTH_TOKEN — JWT from biztada-app shell (App.tsx)
 *   2. SSE_EVENT / SSE_CATCHUP — real-time event relay from SSEHub (useSSE.ts)
 *
 * Must stay in sync with FRAME_APPS origins in biztada-app/DashboardLayout.tsx.
 */
export const SHELL_ORIGINS: string[] = [
  'https://app-biztada.tadagram.com',
  'https://biztada.com',
  'https://www.biztada.com',
  'https://review.biztada.com',    // Internal review/preview shell
  'https://soloai.vn',
  'https://www.soloai.vn',
  'https://app-biztada.pages.dev', // Cloudflare Pages preview deploys
  'https://nguyengiagroup.cloud',    // Whitelabel shell
  'https://www.nguyengiagroup.cloud',
  'http://localhost:5173',          // Vite dev server (biztada-app)
  'http://localhost:3000',          // Alternative dev port
];

export const getIframeParentOrigin = (): string | null => {
  if (window === window.parent) return null;
  const referrer = document.referrer;
  if (!referrer) return null;
  try {
    return new URL(referrer).origin;
  } catch {
    return null;
  }
};

export const isTrustedShellOrigin = (origin: string): boolean => {
  if (SHELL_ORIGINS.includes(origin)) return true;
  const parentOrigin = getIframeParentOrigin();
  return !!parentOrigin && parentOrigin === origin;
};
